import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { BackgroundLoadNotEnabledErrorMessage } from '@ms/yammer-web-support/dist/errors/constants';
import { getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import { getRingId } from '@ms/yammer-web-support/dist/metaOsHub/persistRingInfo';

import { persistAppNameKey, persistConfig } from '../../../persistedState';

type ValidateIfBackgroundLoadEnabled = () => Promise<void>;
export const validateIfBackgroundLoadEnabled: ValidateIfBackgroundLoadEnabled = async () => {
  const isPrecacheRoute = getUrlRootPath(window.location.pathname) === 'precache';
  const isR4User = (await getRingId(persistAppNameKey)) === 'general';

  if (!isPrecacheRoute || !isR4User) {
    return;
  }

  const isR4PrecacheEnabled = (await getPersistedExperimentTreatment(
    persistConfig.key,
    'TeamsBrandedExperiencesBackgroundLoadR4Rollout'
  )) as boolean;

  if (!isR4PrecacheEnabled) {
    throw new Error(BackgroundLoadNotEnabledErrorMessage);
  }
};
